module.exports = __webpack_public_path__ + "img/8_High-body+LC.16fa9985.png";